import { FC, CSSProperties, useState } from "react";
import { ReactComponent as EyeIcon } from "@/assets/icons/eye.svg";
import { ReactComponent as EyeOffIcon } from "@/assets/icons/eye-off.svg";
import "./style.scss";

interface InputPassPropsTypes {
  placeholder?: string;
  value: any;
  style?: CSSProperties;
  disabled?: boolean;
  withIcon?: boolean;
  required?: boolean;
  onChange?: (e: any) => void;
  isError?: boolean;
  errorText?: string;
}

const InputPass: FC<InputPassPropsTypes> = ({
  placeholder = "password",
  value,
  style,
  disabled,
  withIcon = true,
  required = false,
  onChange,
  isError = false,
  errorText,
}) => {
  const [visible, setVisible] = useState<Boolean>(false);

  const seePassword = () => {
    let x = document.getElementById("password");
    //@ts-ignore
    if (x.type === "password") {
      //@ts-ignore
      x.type = "text";
    } else {
      //@ts-ignore
      x.type = "password";
    }
  };

  return (
    <>
      <div className={`input-pass-wrapper`}>
        <input
          type="password"
          id="password"
          className={`input-pass-component ${disabled ? "disabled" : ""}`}
          style={style}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          required={required}
        />

        {withIcon && !visible && (
          <EyeIcon
            onClick={() => {
              setVisible(!visible);
              seePassword();
            }}
            className="eye-icon"
          />
        )}
        {withIcon && visible && (
          <EyeOffIcon
            onClick={() => {
              setVisible(!visible);
              seePassword();
            }}
            className="eye-icon"
          />
        )}
      </div>
      {isError && (
        <span className="input-password-component-error-text">{errorText}</span>
      )}
    </>
  );
};

export default InputPass;
